import { render, staticRenderFns } from "./MembershipPrice.vue?vue&type=template&id=1cc4dbc7&"
import script from "./MembershipPrice.vue?vue&type=script&lang=js&"
export * from "./MembershipPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports